import { Plus } from "react-feather";
import { Href } from "../../../../../Constants/Constants";
import { dynamicImage, dynamicNumber, Image } from "../../../../../Utils";
import useOutside from "../../../../../Utils/useOutside";

const UserGroup = () => {
  const { ref, isComponentVisible, setIsComponentVisible } = useOutside(false);

  return (
    <li className="groupuser">
      <h4>Jewellery project</h4>
      <div ref={ref} className={`gr-chat-friend-toggle ${isComponentVisible && "active"}`}>
        <a className="icon-btn btn-sm pull-right add-grbtn outside" href={Href} onClick={() => setIsComponentVisible(!isComponentVisible)}>
          <Plus />
        </a>
        <div className={`gr-chat-frind-content ${isComponentVisible ? "d-block" : "d-none"}`}>
          <ul className="chat-main">
            {dynamicNumber(4).map((item, index) => (
              <li key={index}>
                <div className="chat-box">
                  <div className="d-flex">
                    <div className={`profile ${item === 1 ? "offline" : item === 4 ? "unreachable" : ""}`}>
                      <Image className="bg-img" src={dynamicImage(`contact/${item}.jpg`)} alt="#" />
                    </div>
                    <div className="details">
                      <h4>Josephin water</h4>
                      <h5>Alabma , USA</h5>
                    </div>
                    <div className="flex-grow-1">
                      <a className="icon-btn btn-outline-primary btn-sm" href={Href}>
                        <i className="fa fa-plus" />
                      </a>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
      {dynamicNumber(2).map((item, index) => (
        <div className="gr-profile dot-btn dot-success grow" key={index}>
          <Image className="bg-img img-fluid" src={dynamicImage(`avtar/${item + 2}.jpg`)} alt="#" />
        </div>
      ))}
    </li>
  );
};

export default UserGroup;
